<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>

export default {
  name: 'App',

mounted(){
  this.$session.start();
}
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Sarabun&display=swap");
* {
  font-family: "Sarabun", sans-serif !important;
}
body{
  height: 100%;
}
</style>
